// JavaScript for handling SPF record building
document.addEventListener('DOMContentLoaded', function() {
  // Function to handle build SPF record button click
  const buildSpfRecordBtn = document.getElementById('build-spf-record-btn');
  
  if (buildSpfRecordBtn) {
    buildSpfRecordBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const domainId = this.dataset.domainId;
      const url = `/domains/${domainId}/hosted_spfs/build_spf_record`;
      
      // Show loading state
      const resultContainer = document.getElementById('built-spf-record');
      if (resultContainer) {
        resultContainer.innerHTML = '<div class="p-4 text-sm text-gray-700 bg-gray-100 rounded-lg">Building SPF record...</div>';
      }
      
      // Fetch the built SPF record
      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          // Display the built SPF record
          if (resultContainer) {
            resultContainer.innerHTML = `
              <div class="mb-4 bg-white rounded-lg shadow-md overflow-hidden">
                <div class="p-4">
                  <div class="overflow-hidden border border-gray-200 rounded-lg">
                    <table class="w-full">
                      <tbody>
                        <tr class="hover:bg-gray-50">
                          <td class="px-4 py-3 text-sm font-mono text-gray-700">
                            ${data.spf_record}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>`;
          }
        } else {
          // Display error message
          if (resultContainer) {
            resultContainer.innerHTML = `
              <div class="p-4 mb-4 text-sm text-red-700 bg-red-50 rounded-lg">
                <p>${data.message || 'Failed to build SPF record'}</p>
              </div>`;
          }
        }
      })
      .catch(error => {
        console.error('Error building SPF record:', error);
        if (resultContainer) {
          resultContainer.innerHTML = `
            <div class="p-4 mb-4 text-sm text-red-700 bg-red-50 rounded-lg">
              <p>An error occurred while building the SPF record. Please try again.</p>
            </div>`;
        }
      });
    });
  }
});
